export default (isOffline, action, errorMessage, showErrorToast) => {
  if (isOffline) {
    return showErrorToast(errorMessage);
  }
  return action();
};
